const ErrorMessage = ({
  title = "Serviço temporariamente indisponível",
  description = "Nossa equipe já está trabalhando para restabelecer o acesso o mais breve possível.",
}) => (
  <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
    <div className="bg-blue-50 border border-blue-100 rounded-2xl p-10 max-w-lg w-full shadow-sm">
      <div className="text-5xl mb-5">🏛️</div>
      <h2 className="text-xl font-bold text-blue-950 mb-2">{title}</h2>
      <p className="text-gray-600 text-sm leading-relaxed">{description}</p>
      <p className="mt-4 text-xs text-gray-400">
        Se o problema persistir, entre em contato com a administração municipal.
      </p>
    </div>
  </div>
);

export default ErrorMessage;
